<template>
  <div class="filter-select" :class="{'filter-select--active': this.value}">
    <label class="filter-select__label" :class="{'sr-only': !this.value}" :for="label">{{ label }}</label>
    <div v-if="icon">
        <svg xmlns="http://www.w3.org/2000/svg" :width="icon.width" :height="icon.height" :viewBox="icon.viewBox">
        <use :href="icon.url"></use></svg>
    </div>
    <select ref="filterSelectInput" class="filter-select__input" :id="label" :name="label" :value="value" @input="emitValue($event.target.value)">
      <option value="">
        {{ label }}
      </option>
      <option v-for="(item, index) in options" :value="useValue ? item.Id : item.Name" :key="`${label}-${index}`">
        {{ item.Name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        useValue: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: String,
            required: true
        },
        icon: {
            type: Object,
            required: false,
            default: {}
        }
    },
    methods: {
        emitValue(selectedTag) {
            if(this.value != selectedTag) {
                this.$emit('input', selectedTag)
                this.$emit('hasChanged', true)
            }
        }
    }
}
</script>